module.exports = __webpack_public_path__ + "img/about-icon.99902c88.svg";